import React from 'react';

import { useTranslation } from 'react-i18next';

import { MetaMaskConnectButton, MetaMaskToolTip, MintTile } from '@pkg/components';
import { useAppDispatch, useAppSelector, useMetaMask } from '@pkg/hooks';

import { AssetTypes } from '@app/client/common/structs/general';
import { ArtifactMintSteps } from '@app/client/common/structs/nft/artifacts';
import { setArtifactMintPanelStep } from '@app/store/actions/artifacts';

import { CallOut, Typography } from '../../../DesignSystem';
import '../ArtifactMintPanel.scss';

interface MintArtifactProps {
    artifactCount?: number;
}

export const MintArtifact = ({ artifactCount = 1 }: MintArtifactProps) => {
    const { t } = useTranslation(['nft', 'words']);
    const { isMetaMaskConnected, isMetaMaskInstalled } = useMetaMask();
    const { selectedArtifact } = useAppSelector((state) => state.artifacts);
    const dispatch = useAppDispatch();
    const onMetaMaskContinue = () => {
        dispatch(setArtifactMintPanelStep(ArtifactMintSteps.AcceptTerms));
    };
    const successCallback = isMetaMaskInstalled && isMetaMaskConnected ? onMetaMaskContinue : undefined;

    return (
        <div className="yat-artifact-sidebar__step">
            <div className="yat-artifact-sidebar__content">
                <Typography type="headline" size={40} classes={['yat-artifact-sidebar__title']}>
                    {artifactCount === 1
                        ? t('mint_your_artifact')
                        : t('mint_your_artifact_plural', { count: artifactCount })}
                </Typography>
                <Typography type="paragraph" size={16} classes={['yat-artifact-sidebar__text']} weight="600">
                    <span>{t('metamask_not_installed_text', { item: t('words:artifact') })}</span> 🎉
                </Typography>
                {selectedArtifact && (
                    <div className={`yat-artifact-sidebar__preview`}>
                        <MintTile
                            artifactType={selectedArtifact.artifact_type}
                            artifactId={selectedArtifact.artifactId}
                            hideButton
                        />
                    </div>
                )}
                <CallOut verticalMargins={30} />
                <MetaMaskConnectButton
                    size={'hero'}
                    successCallback={successCallback}
                    assetType={AssetTypes.Artifact}
                />
            </div>
            {/*todo - make component for this*/}
            {!isMetaMaskConnected && <MetaMaskToolTip />}
        </div>
    );
};
